module.exports = __webpack_public_path__ + "img/electric_enabled_selected.331f3f7e.svg";